import { inject, Injectable } from '@angular/core';
import { MemberClient } from '../client';
import { Member, Members } from '../model/member.model';
import { combineLatest, Observable, of, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MemberStoreService {
    private readonly _client = inject(MemberClient);
    private readonly _cache = new Map<string, Member>();

    getById(userId: string, { noCache = false }: { noCache?: boolean } = {}): Observable<Member> {
        if (noCache) this._cache.delete(userId);

        const cached = this._cache.get(userId);
        if (cached != null) return of(cached);
        return this._client.getById(userId).pipe(
            tap((member: Member) => {
                this._cache.set(userId, member);
                return member;
            })
        );
    }

    getByIds(userIds: string[], { noCache = false }: { noCache?: boolean } = {}): Observable<Members> {
        return combineLatest(userIds.map(userId => this.getById(userId, { noCache })));
    }
}
